import React from "react";
import styles from "./Thinking.module.scss";
import { withRouter } from 'react-router-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import NrgPage from '../NrgPage.jsx';
// import App from './../../app/App';
import DocumentHead from './../../components/DocumentHead.jsx';
import CommonClientScripts from './../../components/CommonClientScripts.jsx';
import GenericHeader from './../../components/Header/GenericHeader.jsx';
import OverlappingContentBox from './../../components/OverlappingContentBox/OverlappingContentBox.jsx';
import RegularContentBox from './../../components/RegularContentBox/RegularContentBox.jsx';
import JourneyContinueBox from './../../components/JourneyContinueBox/JourneyContinueBox.jsx';
import Footer from './../../components/Footer/Footer.jsx';
import PageTransitioner from '../../components/PageTransitioner.jsx';
import NewsPanel from './../../components/NewsPanel/NewsPanel.jsx';

import ScrollItemManager from './../../utils/ScrollItemManager';
import scrollItemConfig from './ScrollConfig';
import { changePageTitle } from "../../utils/pageSetup/pageSetup";

class Thinking extends NrgPage {
    constructor(props) {
        super(props);

        this.page = 'homepage';

        this.state = {
            newsOpen: false
        };
    }

    componentDidMount() {
        changePageTitle(this.page);

        this.scrollItemManager = new ScrollItemManager()
        this.scrollItemManager.setup(scrollItemConfig)
    }
    render() {
        return (
            <div className={[this.page, "container-fluid"].join(" ")}>
                <PageTransitioner page={this.page}>

                    {/* <ReactCSSTransitionGroup
                        transitionName="news"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnterTimeout={300}
                        transitionLeaveTimeout={300}>
                        {newsPanel}
                    </ReactCSSTransitionGroup> */}

                    <GenericHeader page={this.page} newsActions={this.newsActions} />

                    <OverlappingContentBox page={this.page} />
                    <RegularContentBox page={this.page} />
                    <JourneyContinueBox nextPage="Services" nextPageHref="/services" />
                    <Footer />

                </PageTransitioner>
            </div>
        );
    }
}

export default withRouter(Thinking);
